<template>
  <v-row>
    <v-col v-if="isTracked">
      <v-col
        cols="12"
        md="8"
      >
        <v-text-field
          v-model="sku"
          hide-details="auto"
          label="Enter Product Stock Keeping Unit (sku)"
          outlined
          autofocus
          dense
          :error-messages="message"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-btn
          class="info"
          :disabled="!sku"
          @click="track"
        >
          <v-icon left>
            mdi-search-web
          </v-icon>
          Track
        </v-btn>
      </v-col>
    </v-col>
    <v-col v-else>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-btn @click="isTracked = true">
            Back
          </v-btn>
          <v-card
            outlined
            class="mt-2"
          >
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Remains
                      </th>
                      <th>Sold</th>
                      <th>Stocks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ tracked.totalRemaining }}</td>
                      <td>{{ tracked.totalSold }}</td>
                      <td>{{ tracked.totalStocks }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
          <template>
            <v-card
              outlined
              class="mt-2"
            >
              <v-card-text>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <td>{{ item.name }}</td>
                      </tr>
                      <tr>
                        <th>SKU</th>
                        <td>{{ item.sku }}</td>
                      </tr>
                      <tr>
                        <th>Barcode</th>
                        <td>{{ item.barcode }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </template>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-card outlined>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Remaining Quantity
                      </th>
                      <th>Warehouse</th>
                      <th>Rack #</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="stock in tracked.stocks"
                      :key="stock.name"
                    >
                      <td>{{ stock.quantity }} items</td>
                      <td>{{ stock.warehouse.name }}</td>
                      <td>{{ stock.rackNumber }}</td>
                      <td>
                        <template
                          v-if="item.warehouseSaleFrom === stock.warehouse_id"
                        >
                          <v-icon
                            color="success"
                            dark
                          >
                            mdi-check-circle
                          </v-icon>
                          Selling
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      isTracked: true,
      sku: "",
      tracked: {},
      item: {},
      message: "",
    };
  },

  methods: {
    track() {
      window.axios
        .post("/track-stock", { key: this.$data.sku })
        .then((response) => {
          if (response.data.info) {
            this.$data.tracked = response.data.info;
            this.$data.item = response.data.info.item;
            this.isTracked = false;
          } else {
            this.$data.message = response.data.message;
          }
        });
    },
  },
};
</script>
